import { Moment } from 'moment';
import { Language } from './language';
import { PdfDocumentCategory } from './pdf-document-category';
import { PdfDocumentType } from './pdf-document-type';
import { SystemUser } from './system-user';

export class BookingReportTemplate {

    public isStudentDocument = false;
    public isSchoolDocument = false;

    constructor(
        public body: string,
        public name: string,
        public documentType: PdfDocumentType,
        public documentLanguage: Language,
        public pdfDocumentCategory: PdfDocumentCategory,
        public id?: number,
        public created?: Moment,
        public createdBy?: SystemUser,
        public lastModified?: Moment,
        public lastModifiedBy?: SystemUser
    ){}
}
